$(document).ready(function(){

	// -- update attributes on click --
	$('[aria-expanded]').each(function() {
  	$(this).on('click', function(){
			$(this).attr('aria-expanded', function (i, attr) {
				// -- update tabindex --
				var newTabindexVal = (attr == 'true') ? '-1' : '0';
				$('.header__menus [tabindex]').attr('tabindex',newTabindexVal);
				// -- update aria-expanded --
		    return attr == ('true') ? 'false' : 'true';
			});
		});
	});

	// -- update attributes on focusout (menus) --
	$('.header__menus .header__mainMenu li:last-child a').on('focusout', function() {
  	$('.header__menus [tabindex]').attr('tabindex', '-1');
  	$('.hamburger').removeClass('is-active').attr('aria-expanded', 'false');
  	$('body').removeClass('mainMenu--open');
	});	

});